/* file description */
import * as React from 'react';
import { Modal } from 'antd';
import { Popup, Button } from 'antd-mobile';
import styles from './index.module.less';
import useMetaStore from '@/store/useMetaStore';

export const ModalFullLayout = (props: any) => {
  const { isMobile } = useMetaStore();

  if (isMobile) {
    return (
      <Popup
        {...props}
        position="right"
        bodyStyle={{ width: '100vw' }}
        destroyOnClose
      >
        <div className={styles['popup-box']}>
          <div className={styles['popup-spForm-box']}>
            {props.children}
          </div>
          <div
            className={styles['popup-option-tools']}
          >
            <div
              className={styles['option-btn']}
              onClick={() => {
                props.onCancel();
              }}
            >取消
            </div>
            <div
              className={styles['option-btn']}
              style={{ color: '#0064CE' }}
              onClick={() => props?.onOk()}
            >确定
            </div>
          </div>
          <div className={styles['popup-safe-div']} />
        </div>
      </Popup>
    );
  }

  return (
    <Modal maskClosable={false} {...props} > {props.children} </Modal>
  );
};
